<template>
  <div>
    <!-- Only display voting options if this voter is a resident owner -->
    <div v-if="isVoterResident">
      <elections-header
        icon="contacts"
        :header="question.header"
        :snippet="question.snippet"
        :resume-download-link="question.url"
        :custom-options="customOptions"
        :has-candidates="hasCandidates"
        :num-positions="question.positions"
        :prevent-proxy-deferrals="preventProxyDeferrals"
        :has-election-ranking="hasElectionRanking"
      />

      <vote-list
        :has-candidates="hasCandidates"
        :votes="votes"
        :nominees="nominees"
        :question-id="questionId"
        :votes-left="votesLeft"
        :custom-options="customOptions"
        :num-positions="question.positions"
        :has-election-ranking="hasElectionRanking"
      />

      <elections-buttons
        :button-action-type="buttonActionType"
        :is-disabled="hasDuplicateCandidatesInList"
        @show-abstain-modal="showAbstainModal"
        @show-option-modal="showOptionModal"
        @go-next-question="goNextQuestion"
      />
    </div>

    <!-- Otherwise they are not allowed to vote -->
    <div v-else>
      <h1 class="headline">Skipping: Owner Occupied Director Vote</h1>
      <p>We're skipping this step because you don't occupy this unit.</p>
      <p>
        Only owners that occupy their unit may vote for the position reserved
        for voting by owner-occupied owners. However, your proxy is still
        important for quorum purposes.
      </p>
      <p>Please click on the "Next" button to continue.</p>

      <!-- No other choice but to proceed -->
      <elections-buttons
        button-action-type="next-step"
        @click.native="handleSkip"
        :is-disabled="false"
      ></elections-buttons>
    </div>
  </div>
</template>

<script>
import ElectionsButtons from './ElectionsButtons.vue';
import ElectionsHeader from './ElectionsHeader.vue';
import VoteList from './ElectionsVoteList.vue';

import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'ElectionsOwnerOccupied',
  components: {
    ElectionsButtons,
    ElectionsHeader,
    VoteList
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    questionId: {
      type: [String, Number],
      required: true
    },
    hasCandidates: {
      type: Boolean,
      required: true
    },
    votes: {
      type: Array
    },
    nominees: {
      type: Array
    },
    totalVotes: {
      type: Number
    },
    votesLeft: {
      type: Number,
      required: true
    },
    customOptions: {
      type: Object
    },
    hasDuplicateCandidatesInList: {
      type: Boolean,
      required: true
    },
    meetingOptions: {
      type: Object,
      default() {
        return {};
      }
    },
    preventProxyDeferrals: {
      type: Boolean,
      default: true
    },
    hasElectionRanking: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('resident', ['isVoterResident']),
    buttonActionType() {
      if (this.votesLeft === 0) {
        return 'next-step';
      } else if (this.votesLeft == this.totalVotes) {
        return 'option-modal';
      } else if (this.votesLeft > 0) {
        if (this.hasElectionRanking) return 'next-step';
        return 'abstain-modal';
      }
    }
  },
  methods: {
    ...mapActions('questions', ['updateVote']),
    showAbstainModal() {
      this.$emit('show-abstain-modal');
    },
    goNextQuestion() {
      this.$emit('go-next-question');
    },
    showOptionModal() {
      this.$emit('show-option-modal');
    },
    handleSkip() {
      this.updateVote({
        questionId: this.questionId,
        vote: []
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Questions/Elections/ElectionsOwnerOccupied.vue